import type { HasuraClient } from '@vrplatform/graphql';
import { whereListings } from '../queries';

export const listingsRatesCsvQuery = async (
  client: HasuraClient,
  input: Parameters<typeof whereListings>[0],
  customFeeAutomationId: string
) => {
  const rows = await client.query((q) => {
    const defaultRate = q
      .setting({
        where: {
          tenant_id: { _eq: input.tenantId },
          target: { _eq: '*' },
          leftType: { _eq: 'finalytic.listing' },
          key: { _eq: 'rate' },
          localAutomationId: { _eq: customFeeAutomationId },
        },
        limit: 1,
      })
      .map((setting) => setting.value)[0];

    const rateType = (q
      .setting({
        where: {
          tenant_id: { _eq: input.tenantId },
          key: { _eq: 'rateType' },
          leftType: { _eq: 'automationSetting' },
          automationId: { _eq: customFeeAutomationId },
        },
        limit: 1,
      })
      .map((setting) => setting.value)[0] || 'percentage') as
      | 'percentage'
      | 'flat';

    return q
      .listings({
        where: whereListings(input),
        order_by: [{ calculated_title: 'asc_nulls_first' }],
      })
      .map((listing) => {
        const rate = listing
          .settingsRight({
            where: {
              key: { _eq: 'rate' },
              localAutomationId: { _eq: customFeeAutomationId },
            },
            limit: 1,
          })
          .map((setting) => setting.value)[0];

        const getRate = () => {
          const r = rate || defaultRate || 0;

          if (rateType === 'percentage') {
            return `${r}%`;
          }

          return r;
        };

        return {
          'Listing name': listing.name,
          Rate: getRate(),
          isDefault: !rate ? 'True' : 'False',
          Type: rateType,
        };
      });
  });

  return {
    rows,
  };
};
